import {
  formatOrderType,
  formatTransactionType,
  extractOrderType,
  extractProductType
} from '@javascript/habitual-analytics/brokers/OrderFacade/formatter/formatHelper';
import {
  formatTradingSymbol
} from '@javascript/habitual-analytics/brokers/OrderFacade/formatter/instrumentFormatter';
import _ from 'lodash';
import {
  OrderTypes, ProductTypes
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/common';
import { Insta } from '@javascript/habitual-analytics/brokers/OrderFacade/types/insta';
import { Facade } from '@javascript/habitual-analytics/brokers/OrderFacade/types/facade';

export const Formatter = (() => {

  return {
    placeOrder: (leg: Insta.PlaceOrderDetail): Required<Facade.PlaceOrderDetail> => {
      return {
        tradingSymbol: formatTradingSymbol(leg?.tradingSymbolObj),
        quantity: _.get(leg, 'qty', 0),
        transactionType: formatTransactionType(leg?.transactionType),
        productType: _.get(leg, 'pCode', ProductTypes.MIS),
        validity: _.get(leg, 'ret', ''),
        orderType: {
          type: formatOrderType(_.get(leg, 'prctyp', '')),
          limitPrice: _.toNumber(_.get(leg, 'price', 0)),
          triggerPrice: _.toNumber(_.get(leg, 'trigPrice', 0)),
        },
        referenceOrderId: Math.random().toString().slice(2, 11),
      };
    },

    cancelOrder: (leg: Insta.CancelOrderDetail): Required<Facade.CancelOrderDetail[]> => {
      return [
        {
          tradingSymbol: formatTradingSymbol(leg?.tradingSymbolObj),
          transactionType: formatTransactionType(leg?.orderDetails?.type),
          orderType: {
            type: extractOrderType(_.get(leg, 'orderDetails.extraDetails.product', `/${OrderTypes.MARKET}`)),
            limitPrice: _.toNumber(_.get(leg, 'orderDetails.limitPrice', 0)),
            triggerPrice: _.toNumber(_.get(leg, 'orderDetails.stopPrice', 0)),
          },
          quantity: 0,
          filledQuantity: 0,
          cancelledQuantity: 0,
          productType: extractProductType(_.get(leg, 'orderDetails.extraDetails.product', `${ProductTypes.MIS}/`)),
          validity: 'DAY',
          referenceOrderId: Math.random().toString().slice(2, 11),
          brokerOrderId: _.get(leg, 'orderNo', ''),
          brokerOrderExtras: {},
        },
      ];
    },

    marginCalculation: (leg: Insta.MarginCalculationDetail):
      Required<Facade.MarginCalculationDetail> => {
      return {
        tradingSymbol: formatTradingSymbol(leg?.tradingSymbolObj),
        quantity: _.toNumber(_.get(leg, 'qty', 0)),
        transactionType: formatTransactionType(leg?.transactionType),
        productType: _.get(leg, 'pCode', ProductTypes.MIS),
        orderType: {
          type: formatOrderType(_.get(leg, 'prctyp', '')),
          limitPrice: _.toNumber(_.get(leg, 'price', 0)),
          triggerPrice: _.toNumber(_.get(leg, 'trigPrice', 0)),
        },
        ltp: _.toNumber(_.get(leg, 'ltp', 0)),
      };
    },

    modifyOrder: (leg: Insta.ModifyOrderDetail): Required<Facade.ModifyOrderDetail[]> => {
      return [{
        tradingSymbol: formatTradingSymbol(leg?.tradingSymbolObj),
        quantity: _.get(leg, 'qty', 0),
        transactionType: formatTransactionType(leg?.transactionType),
        productType: _.get(leg, 'extraDetails.productType', ProductTypes.MIS),
        validity: _.get(leg, 'ret', ''),
        orderType: {
          type: formatOrderType(_.get(leg, 'prctyp', '')),
          limitPrice: _.toNumber(_.get(leg, 'price', 0)),
          triggerPrice: _.toNumber(_.get(leg, 'trigPrice', 0)),
        },
        referenceOrderId: Math.random().toString().slice(2, 11),
        filledQuantity: _.toNumber(_.get(leg, 'extraDetails.qty', '0').split('/')[0]),
        cancelledQuantity: 0,
        brokerOrderId: _.get(leg, 'orderNo', ''),
        brokerOrderExtras: {},
      }];
    },
  };
});
